import { openDB } from 'idb';

const openDatabase = async () => {
  const db = await openDB('podshop-db', 2, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('data')) db.createObjectStore('data');
    },
  });

  return db;
};

export const saveIndexedDB = async (key: string, value: string) => {
  const db = await openDatabase();
  const tx = db.transaction('data', 'readwrite');
  const store = tx.objectStore('data');
  await store.put(value, key);
};

export const getIndexedDB = async (key: string) => {
  const db = await openDatabase();
  const tx = db.transaction('data', 'readonly');
  const store = tx.objectStore('data');
  return store.get(key);
};

export const deleteIndexedDB = async (key: string) => {
  const db = await openDatabase();
  const tx = db.transaction('data', 'readwrite');
  const store = tx.objectStore('data');
  await store.delete(key);
};
